import { render, staticRenderFns } from "./allVideo.vue?vue&type=template&id=cb6eddfe&scoped=true&"
import script from "./allVideo.vue?vue&type=script&lang=js&"
export * from "./allVideo.vue?vue&type=script&lang=js&"
import style0 from "./allVideo.vue?vue&type=style&index=0&id=cb6eddfe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6eddfe",
  null
  
)

export default component.exports